<template>
  <div>
    <search-form
      :fetchData="fetch"
      ref="searchFormRef"
      :handelSearch="handelSearch"
      :collection="formCollection"
      :addBtn="false"
    ></search-form>
    <a-modal
      v-model:open="open"
      :title="pageName"
      :footer="null"
      :destroyOnClose="true"
      :keyboard="false"
      class="action-form-model"
    >
      <action
        :v-if="open"
        @submit="clickOk"
        :isEdit="false"
        :editData="editData"
        :data="tableData"
        :idField="idField"
      ></action>
    </a-modal>
    <a-modal
      v-model:open="handelAlarmOpen"
      title="处理告警"
      :footer="null"
      :destroyOnClose="true"
      :keyboard="false"
      class="action-form-model-small"
    >
      <handelAlarm
        :v-if="handelAlarmOpen"
        @submit="handelAlarmOk"
        :isEdit="false"
        :editData="editData"
        :data="tableData"
        :idField="idField"
      ></handelAlarm>
    </a-modal>
    <a-table
      :columns="columns"
      :row-key="(record) => record.uuid"
      :data-source="tableData"
      :pagination="pagination"
      :loading="loading"
      @change="handleTableChange"
      :scroll="{x: 'max-content'}"
      size="small"
    >
      <template #bodyCell="{ column, record }">
        <template v-if="column.key === 'visit_area'">
          {{
            codeToText(record.application_info.visit_area, Enum.areaType.value)
          }}
        </template>
        <template v-else-if="column.key === 'interviewee_depart_id'">
          {{
            codeToText(
              record.application_info.interviewee_depart_id,
              Enum.dept.value
            )
          }}
        </template>
        <template v-else-if="column.key === 'level'">
          {{ codeToText(record.level_type, strandedLevel) }}
        </template>
        <template v-else-if="column.key === 'vehicle_type_id'">
          {{ codeToText(record.vehicle_type_id, Enum.carModel.value) }}
        </template>
        <template v-else-if="column.key === 'sms_send'">
          {{ codeToText(record.sms_send, strandedSmsStatus) }}
        </template>
        <template v-else-if="column.key === 'false_alarm'">
          {{ codeToText(record.false_alarm, strandedFalseAlarm) }}
        </template>
        <template v-else-if="column.key === 'state'">
          {{ codeToText(record.application_info.state, Enum.status.value) }}
        </template>
        <template v-else-if="column.key === 'visitor_begin_time'">
          {{ record.application_info.visitor_begin_time }} 至
          {{ record.application_info.visitor_end_time }}
        </template>
        <template v-else-if="column.dataInObject">
          {{
            record[column.dataInObject] &&
            record[column.dataInObject][column.dataIndex]
          }}
        </template>
        <template v-else-if="column.key === 'action'">
          <span>
            <a-button
              @click="showDetailModal(record)"
              :loading="loadingRecord === record[idField] + 'detail'"
            >
              详情
            </a-button>
            &nbsp;&nbsp;
            <a-button @click="showHandelAlarmModal(record)">告警处理</a-button>
          </span>
        </template>
      </template>
    </a-table>
  </div>
</template>
<script setup>
  import { ref, onMounted, toRefs } from 'vue'
  import { useStore } from 'vuex'
  import { getData, alarmDeal, getDetail } from '@/api/stranded_management/car'
  import action from './action'
  import handelAlarm from './action/handelAlarm.vue'
  import { message } from 'ant-design-vue'
  import searchForm from '@/components/search_form'
  import dayjs from 'dayjs'
  import { codeToText } from '@/utils/format'
  import {
    strandedLevel,
    strandedSmsStatus,
    strandedFalseAlarm,
    yesOrNot,
  } from '@/utils/common'
  //初始化
  const pageName = '人员滞留管理'
  const idField = 'id' //响应数据的id的字段名
  const store = useStore()
  const Enum = toRefs(store.state.common)

  //1、搜索框
  const formCollection = [
    {
      type: 'dateRange',
      startField: 'start_time',
      endField: 'end_time',
      label: '时间范围',
      defaultStart: dayjs().subtract(7, 'day').format('YYYY-MM-DD'),
      defaultEnd: dayjs().add(1, 'day').format('YYYY-MM-DD'),
    },
  ]
  const searchFormRef = ref()
  function handelSearch() {
    pagination.value.current = 1
    fetch()
  }

  //2、表格
  const columns = [
    {
      title: '预约受理单号',
      key: 'application_number',
      dataIndex: 'application_number',
      align: 'left',
      dataInObject: 'application_info',
    },
    {
      title: '车牌号码',
      key: 'license_plate',
      dataIndex: 'license_plate',
      align: 'left',
      dataInObject: 'application_info',
    },
    {
      title: '车型',
      dataIndex: 'vehicle_type_id',
      key: 'vehicle_type_id',
      align: 'left',
      dataInObject: 'application_info',
    },
    {
      title: '姓名',
      dataIndex: 'applicant_name',
      key: 'applicant_name',
      align: 'left',
      dataInObject: 'application_info',
    },
    {
      title: '电话',
      dataIndex: 'applicant_phone',
      key: 'applicant_phone',
      align: 'left',
      dataInObject: 'application_info',
    },
    {
      title: '等级',
      dataIndex: 'level',
      key: 'level',
      align: 'left',
    },
    {
      title: '短信状态',
      dataIndex: 'sms_send',
      key: 'sms_send',
      align: 'left',
    },
    {
      title: '处理结果描述',
      dataIndex: 'handled_remark',
      key: 'handled_remark',
      align: 'left',
    },
    {
      title: '是否误报',
      dataIndex: 'false_alarm',
      key: 'false_alarm',
      align: 'left',
    },
    {
      title: '入园时间',
      dataIndex: 'visitor_begin_time',
      key: 'visitor_begin_time',
      align: 'left',
    },
    {
      title: '告警时间',
      dataIndex: 'alarm_time',
      key: 'alarm_time',
      align: 'left',
    },
    {
      title: '操作',
      dataIndex: 'action',
      key: 'action',
      align: 'left',
      fixed: 'right',
      width: '200px',
    },
  ]

  const tableData = ref([])
  const loading = ref(false)
  const loadingRecord = ref()
  const pagination = ref({
    current: 1,
    pageSize: 10,
    showLessItems: true,
    showQuickJumper: true,
    showSizeChanger: true,
  })

  function handleTableChange(page) {
    pagination.value = { ...pagination.value, ...page }
    fetch()
  }

  function fetch() {
    //获取表单值
    const formState = searchFormRef.value?.formState

    loading.value = true
    getData({
      size: pagination.value.pageSize,
      pn: pagination.value.current,
      ...formState,
    }).then(({ data }) => {
      loading.value = false
      tableData.value = data.list
      pagination.value.total = data.total
    })
  }
  onMounted(fetch)

  //3、编辑、添加
  const open = ref(false)
  const editData = ref(null)

  const showDetailModal = async (data) => {
    loadingRecord.value = data + 'detail'
    const detail = await fetchDetail(data[idField])
    loadingRecord.value = null
    if (detail) {
      editData.value = detail
      open.value = true
    }
  }

  async function fetchDetail(id) {
    const res = await getDetail({ id })
    if (res.success) {
      return res.data
    } else {
      message.warn('获取详情失败')
    }
  }

  function clickOk() {
    fetch()
    handleOk()
    clearEditData()
  }

  const handleOk = () => {
    open.value = false
  }
  const clearEditData = () => {
    editData.value = null
  }

  //4、处理告警
  const handelAlarmOpen = ref(false)
  function handelAlarmOk() {
    fetch()
    handelAlarmOpen.value = false
    clearEditData()
  }
  const showHandelAlarmModal = async (data) => {
    editData.value = data
    handelAlarmOpen.value = true
  }
</script>
